import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BackPainPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Back Pain</h1>
        <section className="mb-8">
          <p>Back pain is one of the most common health complaints, affecting people of all ages and lifestyles. It can range from a dull, constant ache to sudden, sharp pain, often interfering with daily activities. While back pain can have many causes, natural therapies can offer lasting relief without dependency on painkillers.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Muscle strain or injury</li>
            <li>Poor posture</li>
            <li>Sedentary lifestyle</li>
            <li>Herniated discs</li>
            <li>Stress or tension</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Persistent or intermittent pain in the back</li>
            <li>Stiffness or reduced flexibility</li>
            <li>Muscle spasms</li>
            <li>Pain radiating to legs or buttocks</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use a combination of herbal oils, natural therapies, and gentle exercises to reduce inflammation, relax muscles, and restore mobility. Our holistic philosophy addresses both the physical and emotional aspects of back pain for comprehensive healing.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-addictive pain relief</li>
            <li>Reduces inflammation naturally</li>
            <li>Improves flexibility and strength</li>
            <li>Supports long-term spinal health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Practice regular stretching and yoga</li>
            <li>Maintain good posture</li>
            <li>Use ergonomic furniture</li>
            <li>Manage stress with relaxation techniques</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help chronic back pain?</strong>
            <p>A: Yes, our approach is effective for both acute and chronic cases.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Will I need to stop my current medications?</strong>
            <p>A: No, our treatments can complement your existing plan.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does it take to feel better?</strong>
            <p>A: Many patients experience relief within a few sessions.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Don't let back pain hold you back—schedule your natural therapy session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default BackPainPage; 